module.exports = __webpack_public_path__ + "static/media/office-960.6e8e35f5.jpg";